import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpPlus } from '../../http-plus';
import { Location } from '@angular/common';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Fce } from '../../fce';
import { SharedService } from '../../../_shared/shared.service';
import { DbConstants } from 'src/app/_consts/db-constants';
import { Product } from 'src/app/_models/product';
import { SafePipe } from 'src/app/SayTS/directives/safe';

@Component({
  selector: 'app-i-frame',
  templateUrl: './i-frame.component.html',
  imports: [SafePipe],
})
export class IFrameComponent implements OnInit, OnDestroy {
  @Input() internal: boolean = false
  @Input() app: string
  @Input() path: string

  public appPath;
  public _bread;
  public loaded: boolean = false

  iframeId: string = 'iframe-app'
  iframe: any = null
  onIframeMessage = null
  extraUrl

  constructor(private activatedRoute: ActivatedRoute, private router: Router, public shared: SharedService, private http: HttpPlus,
    private location: Location, private modal: NgxSmartModalService) {

  }

  ngOnInit() {
    //Get extra URL
    let extraUrl = this.router.routerState.snapshot && this.router.routerState.snapshot.url
    let appPath = this.activatedRoute.snapshot.url.map(e => e.path).join("/")
    if (extraUrl) {
      if (!extraUrl.startsWith("/"))
        extraUrl = `/${extraUrl}`
      if (!appPath.startsWith("/"))
        appPath = `/${appPath}`
      if (extraUrl.startsWith(appPath))
        extraUrl = extraUrl.replace(appPath, "")

      this.extraUrl = extraUrl
    }

    //Get iframe-app URL
    this.shared.loadedIframe = this;
    this.app = this.activatedRoute.snapshot.data.app;
    if (environment.appPaths && environment.appPaths[this.app]) {
      this.appPath = `${environment.appPaths[this.app]}?${environment.version}`;
    } else {
      this.router.navigate(["dashboard"]);
    }

    const self = this;
    self.onIframeMessage = function (e) {
      if (e && e.data) {
        let msgData = null, msgType = null;
        try {
          const json = JSON.parse(e.data);
          msgType = json.type;
          msgData = json.data;
        } catch (error) {
          msgType = e.data;
        }
        if (msgType && msgType.type) {
          msgData = msgType.data;
          msgType = msgType.type;
        }
        // console.log("SUB APP MESSAGE PARSED:", msgType, msgData);
        switch (msgType) {
          case 'LOADED':
            self.loaded = true
            self.changeLanguage(self.shared.transService.currentLang);
            break;
          case 'GET_LOGIN':
            self.sendLogin(true, false);
            self.sendExtraUrl()
            break;
          case 'GET_LOGIN_V2':
            self.sendLogin(true, true);
            self.sendExtraUrl()
            break;
          case 'YOU_GO_HOME':
            self.router.navigate(["dashboard"]).then(() => {
              self.shared.setLoading(false)
            });
            break;
          case 'LOADING':
            self.shared.setLoading(msgData)
            break;
          case 'NOTIFICATION':
            switch (msgData.type) {
              case 'SUCCESS':
                self.shared.success(msgData.head, msgData.text)
                break;
              case 'INFO':
                self.shared.info(msgData.head, msgData.text, msgData.timeOut)
                break;
              case 'WARNING':
                self.shared.warning(msgData.head, msgData.text, msgData.timeOut)
                break;
              case 'ERROR':
                self.shared.error(msgData.head, msgData.text)
                break;
            }
            break;
          case 'BREAD':
            if (msgData) {
              self.setUrl(msgData)
              // const breads = msgData.split("/").filter(
              //   (e) => { return e && e.length > 0 });

              // self.bread = breads.join('/');
            }
            break;
          case 'NEW_VERSION':
            if (msgData) {
              self.http.post("msg/message", { type: msgType, app: self.app, scenario: msgData.scenario })
            }
            break;
          case 'NAVIGATE':
            if (msgData.url) {
              if (msgData.wait) {
                self.router.navigate(['empty'])
                requestAnimationFrame(() => self.router.navigate([msgData.url]))
              }
              else
                self.router.navigate([msgData.url])
            } else
              self.router.navigate([msgData])
            break;
          case 'GET_ROUTER_DATA':
            const data = {
              type: "ROUTER_DATA",
              data: self.activatedRoute.snapshot.data
            };
            self.postMessage(data);
            break;
          case 'SHOW_LOGIN_DIALOG':
            self.shared.broadcast("SHOW_LOGIN_MODAL", (data) => {
              self.sendModalLogin(data)
            })
            break;
          case 'SELECT_PRODUCT':
            if (msgData.id_project)
              self.shared.product = new Product(msgData)
            break;
          case 'SHOW_FILE_FLOAT':
            self.shared.broadcast("SHOW_FILE_FLOAT", msgData)
            break;
        }
      }
    }
    window.addEventListener('message', this.onIframeMessage, false);

    this.shared.productWatch?.subscribe(() => {
      if (this.loaded)
        this.sendProduct()
    })
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.onIframeMessage);
  }

  onIframeLoaded() {
    this.iframe = document.getElementById(this.iframeId);
  }

  reloadIframe() {
    console.log("RELOADING IFRAME")
    if (!this.iframe)
      this.iframe = document.getElementById(this.iframeId);
    if (this.iframe && this.iframe.contentWindow) {
      this.iframe.contentWindow.location.reload();
    }
  }

  postMessage(data) {
    if (!this.iframe)
      this.iframe = document.getElementById(this.iframeId);
    if (this.iframe && this.iframe.contentWindow) {
      this.iframe.contentWindow.postMessage(JSON.stringify(data), "*");
    }
  }

  print() {
    if (this.iframe && this.iframe.contentWindow)
      this.iframe.contentWindow.print();
  }

  goBack() {

    const data = {
      type: "GO_BACK",
    };
    this.postMessage(data);
  }

  goHome() {
    const data = {
      type: "GO_HOME",
    };
    this.postMessage(data);
  }

  changeLanguage(lang) {
    const data = {
      type: "SET_LANGUAGE",
      data: {
        lang,
        translations: this.shared.transService.translations
      }
    };
    this.postMessage(data);
  }

  sendLogin(addProduct = false, v2 = true) {
    const data = {
      type: "LOGIN",
      data: null
    };
    if (v2) {
      data.data = {
        login: {
          ...this.shared.login,
          ...(this.shared.rightsAll[this.app.toUpperCase()] || {})
        },
        product: addProduct ? this.shared.product : null,
        constants: DbConstants.toJson()
      }
    } else {
      data.data = {
        ...this.shared.login,
        ...(this.shared.rightsAll[this.app.toUpperCase()] || {}),
        product: addProduct ? this.shared.product : null,
        constants: DbConstants.toJson()
      }
    }
    console.log("SEND LOGIN")
    this.postMessage(data);
  }

  sendModalLogin(login) {
    const data = {
      type: "MODAL_LOGIN",
      data: login
    };
    console.log(data)
    this.postMessage(data);
  }

  sendProduct() {
    const data = {
      type: "PRODUCT",
      data: this.shared.product
    };
    this.postMessage(data);
  }

  sendExtraUrl() {
    if (!Fce.empty(this.extraUrl)) {
      const data = {
        type: "EXTRA_URL",
        data: this.extraUrl
      };
      //  console.log(data)
      this.postMessage(data);
      this.extraUrl = null;
    }
  }

  setUrl(exUrl = "") {
    if (this.activatedRoute && this.activatedRoute.snapshot) {
      const baseUrl = this.activatedRoute.snapshot.url.map(e => e.path).join("/")
      if (exUrl.startsWith("/"))
        exUrl = exUrl.substring(1)
      if (!Fce.empty(exUrl) && exUrl != baseUrl)
        this.location.replaceState(`${baseUrl}/${exUrl}`)
      else
        this.location.replaceState(baseUrl)
    }
  }

  set bread(bread) {
    const trans = []
    bread.forEach(e => {
      e = `breads.${e}`
      const t = this.shared.transService.instant(e)
      if (t != e && t !== '')
        trans.push(t)
    });
    console.log("breads", bread, trans)
    this._bread = trans
  }

  get bread() {
    return this._bread
  }
}
